import { render, staticRenderFns } from "./DepartmentUserImportForm.vue?vue&type=template&id=31b93480&scoped=true"
import script from "./DepartmentUserImportForm.vue?vue&type=script&lang=js"
export * from "./DepartmentUserImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b93480",
  null
  
)

export default component.exports